import React from 'react';
import Animated from 'components/generals/AnimatedComponent';
import ContactForm from 'components/generals/forms/contact';
export default function Home__section__5() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__5" id="contacto">
            <section className="nv__section__container">
                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                    <h1>
                        TE GUSTARÍA SER ATENDIDO <br />
                        POR UN EXPERTO FINANCIERO
                    </h1>
                </Animated>
                <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                    <p>Déjanos tus datos y en breve uno de nuestros expertos estará contigo.</p>
                </Animated>
                <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                    <div className="contacFormBlock">
                        <ContactForm />
                    </div>
                </Animated>
            </section>
        </main>
    );
}
